const ApiAccordions = {
    'body': '',
    'start': function() {
        let self = this;
        self.init();

        self.initAccordions();
        self.setAccordion();
    },
    'setAccordion': function(){
        let self = this;

        let accordions = self.body.find('div.accordions');
        accordions.each(function() {
            let thisAccordions = $(this);
            let accordionItems = thisAccordions.find('div.accordion-item');
            accordionItems.unbind('click');
            accordionItems.each(function() {
                let accordionItem = $(this);
                accordionItem.on('click', function(){
                    let thisClick = $(this);
                    let accordionContent = thisClick.find('div.accordion-content');
                    let accordionContentHeight = accordionContent.attr('accordion-height');
                    let accordionStatus = thisClick.attr('accordion-status');

                    switch(accordionStatus){
                        case 'closed':
                            accordionContent.css('height', '0px');
                            accordionContent.removeClass('hidden');

                            accordionContent.animate(
                                { height: accordionContentHeight+'px'},
                                200,
                                'swing'
                            );

                            thisClick.attr('accordion-status', 'open');
                            break;
                        case 'open':
                            // accordionContent.css('height', '0px');
                            accordionContent.removeClass('hidden');

                            accordionContent.animate(
                                { height: 0+'px'},
                                200,
                                'swing'
                            );
                            thisClick.attr('accordion-status', 'closed');
                            break;
                    }
                });
            });
        });
    },
    'initAccordions': function(){
        let self = this;

        let accordions = self.body.find('div.accordions');
        accordions.each(function(){
            let thisAccordions = $(this);
            let accordionItems = thisAccordions.find('div.accordion-item');
            console.log(accordionItems.length);
            accordionItems.each(function(){
                let accordionItem = $(this);
                let accordionContent = accordionItem.find('div.accordion-content');
                let accordionContentHeight = self.getHiddenHeights(accordionContent);
                accordionContent.attr('accordion-height', accordionContentHeight);
            })
        })
    },

    'getHiddenHeights': function(accordionContent){
        let self = this;

        let $clone = accordionContent.clone()
            .css({
                position: 'absolute',
                visibility: 'hidden',
                display: 'block',
                height: 'auto'
            })
            .appendTo('body');

        let height = $clone.outerHeight(true);
        $clone.remove();

        return height;
    },


    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiAccordions.start();
});
